An array of formatted position profile descriptions.

A maximum of 10 formatted descriptions may be provided.
